import React from 'react';
import { Flame, Activity, AlertCircle, RefreshCw } from 'lucide-react';
import { useScrollReveal } from './useScrollReveal';
export function ProblemSection() {
  const ref = useScrollReveal();
  return <section className="w-full bg-marfil py-16 px-5 flex justify-center" data-id="element-134">
      <div ref={ref} className="fade-up w-full max-w-md flex flex-col gap-6" data-id="element-135">
        <h2 className="font-serif font-bold text-petroleo text-3xl leading-tight" data-id="element-136">
          El problema no es tu tolerancia al dolor.
        </h2>
        <p className="text-gray-700 text-base leading-relaxed" data-id="element-137">
          Tu cuerpo está en un estado de inflamación sistémica crónica. Cada
          mes, sin las herramientas correctas, ese fuego se reaviva. No alcanza
          con una pastilla. Necesitás un protocolo.
        </p>
        <div className="mt-6 flex flex-col gap-0 relative" data-id="element-138">
          <div className="absolute left-[1.3rem] top-6 bottom-6 w-0.5 bg-blush-light z-0" data-id="element-139"></div>
          <div className="flex items-center gap-4 relative z-10 mb-6" data-id="element-140">
            <div className="w-11 h-11 rounded-full bg-white border-2 border-blush flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-141">
              <AlertCircle className="w-5 h-5 text-petroleo" data-id="element-142" />
            </div>
            <div className="bg-white p-3 rounded-xl shadow-sm border border-marfil flex-grow" data-id="element-143">
              <p className="font-semibold text-petroleo text-sm" data-id="element-144">
                Disparadores
              </p>
              <p className="text-xs text-gray-500" data-id="element-145">
                Alimentación, estrés, hormonas
              </p>
            </div>
          </div>
          <div className="flex items-center gap-4 relative z-10 mb-6" data-id="element-146">
            <div className="w-11 h-11 rounded-full bg-white border-2 border-blush flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-147">
              <Activity className="w-5 h-5 text-petroleo" data-id="element-148" />
            </div>
            <div className="bg-white p-3 rounded-xl shadow-sm border border-marfil flex-grow" data-id="element-149">
              <p className="font-semibold text-petroleo text-sm" data-id="element-150">Inflamación</p>
              <p className="text-xs text-gray-500" data-id="element-151">El cuerpo se defiende</p>
            </div>
          </div>
          <div className="flex items-center gap-4 relative z-10 mb-6" data-id="element-152">
            <div className="w-11 h-11 rounded-full bg-white border-2 border-blush flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-153">
              <Flame className="w-5 h-5 text-red-500" data-id="element-154" />
            </div>
            <div className="bg-white p-3 rounded-xl shadow-sm border border-marfil flex-grow" data-id="element-155">
              <p className="font-semibold text-petroleo text-sm" data-id="element-156">
                Dolor Crónico
              </p>
              <p className="text-xs text-gray-500" data-id="element-157">Crisis y agotamiento</p>
            </div>
          </div>
          <div className="flex items-center gap-4 relative z-10" data-id="element-158">
            <div className="w-11 h-11 rounded-full bg-petroleo border-2 border-petroleo flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-159">
              <RefreshCw className="w-5 h-5 text-white" data-id="element-160" />
            </div>
            <div className="bg-petroleo p-3 rounded-xl shadow-sm flex-grow" data-id="element-161">
              <p className="font-semibold text-white text-sm" data-id="element-162">
                Más Disparadores
              </p>
              <p className="text-xs text-salvia-light" data-id="element-163">El ciclo se repite</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}